import {DocumentNode, gql} from '@apollo/client';
import React from 'react';

import DataConnector from 'connect/DataConnector';
import {BoxSchema, StorableSchema} from 'samples/storables/StorableSchemaConstants';
import {SchemaOwnerQuery} from 'schemas/SchemaOwnerUtil';

import {BoxSchemaSelectorOwnerQuery} from './__generated/BoxSchemaSelectorOwnerQuery';
import * as SampleSchemaActions from './SampleSchemaActions';
import SampleSchemaStore from './SampleSchemaStore';
import StorableSchemaSelector from './StorableSchemaSelector';

export interface BoxSchemaSelectorProps {
  error?: string;
  // Called with `(schema | null)` if `shouldShowNoSchemaOption` is true.  Otherwise, called with `(schema)`.
  onChange: (schema: StorableSchema | null) => void;
  registryId?: string;
  selectedBoxSchemaId: string | null;
  // Marked as optional here but there is a default prop for it so we can rely on it being present in the component.
  shouldShowNoSchemaOption?: boolean;
  boxSchemas?: Array<{
    id: string;
    name: string;
  }>;
}

interface EnhancedProps {
  boxSchemas: Array<BoxSchema> | null;
}

export const BOX_SCHEMA_SELECTOR_OWNER_QUERY: DocumentNode = gql`
  query BoxSchemaSelectorOwnerQuery @skipAudit @engComponent(name: INVENTORY) {
    boxSchemas {
      id
      registry {
        id
        organization {
          id
          name
        }
      }
    }
  }
`;

class BoxSchemaSelectorConnector extends DataConnector<BoxSchemaSelectorProps, EnhancedProps> {
  shouldSubscribeToRedux = false;
  stores = [SampleSchemaStore];

  enhanceProps(): EnhancedProps {
    return {boxSchemas: this.sampleSchemaStore().getBoxSchemas(this.props.registryId)};
  }
}

class BoxSchemaSelector extends React.Component<BoxSchemaSelectorProps & EnhancedProps> {
  static defaultProps = {
    shouldShowNoSchemaOption: false,
  };

  componentDidMount(): void {
    SampleSchemaActions.fetchAllBoxSchemas();
  }

  render(): JSX.Element {
    return (
      <SchemaOwnerQuery<BoxSchemaSelectorOwnerQuery>
        query={BOX_SCHEMA_SELECTOR_OWNER_QUERY}
        getIdOwnerTuples={(data) =>
          data.boxSchemas.map((boxSchema) => ({
            id: boxSchema.id,
            owner: boxSchema.registry.organization.name,
          }))
        }
      >
        {({getSchemaOwner}) => (
          <StorableSchemaSelector
            error={this.props.error}
            onChange={this.props.onChange}
            schemas={this.props.boxSchemas}
            selectedSchemaId={this.props.selectedBoxSchemaId}
            shouldShowNoSchemaOption={this.props.shouldShowNoSchemaOption}
            getSchemaOwner={getSchemaOwner}
            // Overridden by props from redux
            starredSchemaIds={[]}
          />
        )}
      </SchemaOwnerQuery>
    );
  }
}

export default BoxSchemaSelectorConnector.connect(BoxSchemaSelector);
